var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineNormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 76,
    viewBox: "0 0 12 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 11.3333C8.94552 11.3333 11.3333 8.94552 11.3333 6C11.3333 3.05448 8.94552 0.666664 6 0.666664C3.05448 0.666664 0.666663 3.05448 0.666663 6C0.666664 8.94552 3.05448 11.3333 6 11.3333ZM7 76L7 6L5 6L5 76L7 76Z",
    fill: "#1D314C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineNormal);
export default __webpack_public_path__ + "static/media/line-normal.db79a295ca50c195543ab98ad783bf0c.svg";
export { ForwardRef as ReactComponent };